import {
    blueGrey700,
    deepOrangeA700, greenA700, grey500
} from 'material-ui/styles/colors'

const palette = {
    primary1Color: '#f4941e',
    primaryColorMute: '#bc6600',
    secondaryColor: blueGrey700,
    accent1Color: '#f4941e',
    textColor: 'rgba(0,0,0,0.8)',
    errorColor: deepOrangeA700,
    successColor: greenA700,
    labelColor: 'rgba(0, 0, 0, 0.8)'
}
const creiosTheme = {
    palette: palette,
    tableRow: {
        stripeColor: 'rgba(0,0,0,0.02)'
    },
    appBar: {
        color: palette.secondaryColor,
    },
    tableHeaderColumn: {
        textColor: palette.textColor,
    },
    tabs: {
        backgroundColor: palette.secondaryColor,
    },
    textField: {
        floatingLabelColor: palette.textColor,
        borderColor: grey500,
    },
    datePicker: {
        headerColor: palette.secondaryColor,
        selectColor: palette.secondaryColor
    }
}

export default creiosTheme

// PLS DONT USE!! IS OUTDATED ONLY NEEDS TO STAY ALIVE CAUSE OF LEGACY CODE



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Theme/creiosTheme.ts